import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitActivityStateProgramIndicatorValues } from "./pit-activity-state-program-indicator-values";
/** Показатели государственных программ */
let PitActivityStateProgramIndicators = class PitActivityStateProgramIndicators {
    get indicatorId() {
        return this._indicatorId;
    }
    set indicatorId(value) {
        this._indicatorId = value;
    }
    get indicatorValues() {
        return this._indicatorValues;
    }
    set indicatorValues(value) {
        this._indicatorValues = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "indicatorId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityStateProgramIndicators.prototype, "_indicatorId", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitActivityStateProgramIndicatorValues, { name: "indicatorValues", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivityStateProgramIndicators.prototype, "_indicatorValues", void 0);
PitActivityStateProgramIndicators = tslib_1.__decorate([
    jsonObject
], PitActivityStateProgramIndicators);
export { PitActivityStateProgramIndicators };
